<template>
  <div id="app">
    <div class="container">
      <!-- Lista de exames cardiológicos do paciente -->
      <b-card v-if="!showExameForm && !loading">
        <b-card-body>
          <div v-if="exames.length === 0" class="text-center py-4">
            <feather-icon
              icon="FileTextIcon"
              size="48"
              class="text-muted mb-2"
            />
            <p class="text-muted">
              Nenhum Exame encontrado para este paciente.
            </p>
            <b-button variant="primary" @click="showModal">
              Criar Primeiro Requisição para Exame
            </b-button>
          </div>

          <b-list-group v-else>
            <div class="justify-content-end d-flex mb-2 flex-wrap">
              <b-button variant="primary" @click="showModal">
                Criar Nova Requisição para Exame
              </b-button>
            </div>
            <b-list-group-item
              v-for="exame in exames"
              :key="exame.id"
              class="d-flex justify-content-between align-items-center"
            >
              <div>
                <h6 class="mb-1">Requisição de Exames #{{ exame.id }}</h6>
                <small>
                  Data: <b>{{ formatHyphenToSlash(exame.dataExame) }}</b>
                </small>
                <br />
                <small>
                  Profissional: <b>{{ exame.profissional.nome }} </b></small
                >
              </div>
              <div>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="mr-1"
                  title="Editar Exame"
                  @click="editExame(exame)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card-body>
      </b-card>

      <!-- Loading spinner -->
      <div v-if="loading" class="text-center py-4">
        <b-spinner variant="primary" label="Carregando..." />
        <p class="mt-2 text-muted">Carregando exames cardiológicos...</p>
      </div>

      <!-- Formulário de odontograma (será mostrado quando showOdontogramaForm = true) -->
      <div v-if="showExameForm" class="justify-content-end d-flex flex-wrap">
        <b-button
          class="mb-3"
          variant="outline-secondary"
          @click="backToList()"
        >
          <feather-icon icon="ArrowLeftIcon" />
          Voltar para Lista
        </b-button>
        <ExameDigital
          class="col-12"
          :exame-prop="exame"
          @disable-form-changed-exame="
            $emit('disable-form-changed-exame', $event)
          "
        />
      </div>
    </div>
    <!-- modal -->
    <b-modal ref="my-modal" hide-footer no-close-on-backdrop>
      <div class="d-block text-center">
        <h3>Requisição para Exames</h3>
        <b-row>
          <!-- situacaoRegistro -->
          <b-col ols="12" lg="12">
            <b-form-group label="Selecione os exames" label-for="v-situacao">
              <v-select
                v-model="examesSelected"
                label="label"
                :options="comboExames"
                multiple
                rule
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-primary"
          block
          :disabled="!examesSelected"
          @click="showMsgBoxCreate"
        >
          Continua
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-danger"
          block
          @click="hideModal"
        >
          Cancelar
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BButton,
  BSpinner,
  BBadge,
  BModal,
  BCol,
  BFormGroup,
  BRow,
} from "bootstrap-vue";
import ExameDigital from "./components/ExameDigital.vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BButton,
    BSpinner,
    BBadge,
    BModal,
    BCol,
    BFormGroup,
    BRow,
    ExameDigital,
    vSelect,
  },
  props: {
    atendimento: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "atendimento.id": {
      handler() {
        this.loadPatientexames();
      },
      immediate: true,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showExameForm: false,
      loading: false,
      exames: [],
      patientId: null,
      currentDate: this.formatDateToDDMMYYYY(new Date()),
      exame: [],
      examesSelected: [],
      comboExames: [],
    };
  },
  mounted() {
    this.loadComboExames();
  },
  methods: {
    async loadComboExames() {
      const response = await this.$store.dispatch("exameModule/combosExames");
      this.comboExames = response.data.map((e) => ({
        label: e.descricao,
        value: e.id,
      }));
    },
    showMsgBoxCreate() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja Criar requisição para os exames selecionados?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.createExame();
            this.hideModal();
          }
        });
    },
    async showModal() {
      this.examesSelected = [];
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.examesSelected = [];
      this.$refs["my-modal"].hide();
    },
    backToList() {
      this.loadPatientexames();
      this.showExameForm = false;
    },
    /**
     * Formata a data para o formato dd-mm-yyyy
     */
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },

    /**
     * Transforma uma data no formato DD-MM-YYYY para DD/MM/YYYY
     */
    formatHyphenToSlash(dateString) {
      if (!dateString) return "";
      try {
        // Verifica se a data está no formato esperado YYYY-MM-DD
        if (
          typeof dateString !== "string" ||
          !/^\d{4}-\d{2}-\d{2}$/.test(dateString)
        ) {
          console.warn("Data não está no formato YYYY-MM-DD:", dateString);
          return dateString;
        }

        // Separa a data em ano, mês e dia
        const [year, month, day] = dateString.split("-");
        // Retorna no formato DD/MM/YYYY
        return `${day}/${month}/${year}`;
      } catch (error) {
        console.error("Erro ao transformar formato da data:", error);
        return "";
      }
    },

    /**
     * Carrega os odontogramas do paciente usando o serviço getPatientById
     */
    async loadPatientexames() {
      this.patientId = this.atendimento.registro.id;
      if (!this.patientId) {
        return;
      }

      this.loading = true;
      try {
        // Usar o serviço diretamente ou através do Vuex
        const response = await this.$store.dispatch(
          "exameModule/getPatientById",
          this.patientId,
        );
        this.exames = (response || response.data || []).sort(
          (a, b) => b.id - a.id,
        );
      } catch (error) {
        console.error("Erro ao carregar exames do paciente:", error);
        this.$bvToast.toast("Erro ao carregar exames do paciente", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    /**
     * Formata a data para exibição
     */
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    /**
     * Edita um Exame existente
     */
    editExame(exame) {
      this.loading = true;
      this.$store
        .dispatch("exameModule/getById", exame.id)
        .then((response) => {
          this.exame = response;
          this.showExameForm = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar exames:", error);
          this.loading = false;
        });
    },

    createExame() {
      this.$store
        .dispatch("exameModule/generate", {
          atendimento: this.atendimento.id,
          data: this.currentDate,
          versao: "v2",
          observacao: "Criando um novo exame",
          exames: this.examesSelected.map((item) => item.value),
          ativo: true,
        })
        .then((response) => {
          if (response.error) {
            this.$bvToast.toast(response.message, {
              title: "Erro",
              variant: "danger",
              solid: true,
            });
            return;
          }
          this.exame = response.data;
          this.editExame(this.exame);
          this.examesSelected = [];
        })
        .catch((e) => {
          this.examesSelected = [];
        });
    },

    /**
     * Atualiza um exame quando o componente ExameForm emite o evento
     */
    updateExame(updatedExame) {
      const index = this.exames.findIndex(
        (exame) => exame.id === updatedExame.id,
      );
      if (index !== -1) {
        this.exames.splice(index, 1, updatedExame);
      }
    },
  },
};
</script>
